import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, InputNumber, Button, Row, Col, Select, notification, Switch, Collapse } from 'antd';
import Toast from 'antd-mobile/lib/toast';
import ColorPicker from 'react-pick-color';

const { Option } = Select;
const { Panel } = Collapse;

@inject(
    'templateStore'
)
@observer
class TemplateUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            uploading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createTemplateOnClick = () => {
        this.props.templateStore.createTemplate().then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: 'Success',
                    description: 'Template is successfully created.',
                    duration: 1
                });
                this.props.templateStore.initTemplate();
            } else {
                notification['error']({
                    message: 'Failed',
                    description: resp.error,
                    duration: 5
                });
                this.props.templateStore.setupdateLoading(false);
            }
        });
    }

    updateTemplateOnClick = () => {
        this.props.templateStore.updateTemplate().then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: 'Success',
                    description: 'Template is successfully updated.',
                    duration: 1
                });
                this.props.templateStore.initTemplate();
            } else {
                notification['error']({
                    message: 'Failed',
                    description: resp.error,
                    duration: 5
                });
                this.props.templateStore.setupdateLoading(false);
            }
        });
    }

    cancelTemplateOnClick = () => {
        this.props.templateStore.setShowUpdateTemplateModal(false);
    }

    render() {
        const {
            fontFamilies,
            template,
            updateLoading
        } = this.props.templateStore;

        let hasError = true;

        if (template) {
            hasError = template.name === '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    template
                        ?
                        <>
                            <Form layout='vertical'>
                                <Row>
                                    {/* Template Name */}
                                    <>
                                        <Col span={6} className='stm-cms-control'>Template Name</Col>
                                        <Col span={18} className='stm-cms-control'>
                                            <Input
                                                value={template.name}
                                                onChange={(e) => this.props.templateStore.setname(e.target.value)}
                                                className='stm-width-200' />
                                            <>
                                                {
                                                    template.name === ''
                                                        ?
                                                        <div className='stm-color-error stm-padding-top-4'>* Required</div>
                                                        :
                                                        null
                                                }
                                            </>
                                        </Col>
                                    </>

                                    {/* Active */}
                                    <>
                                        <Col span={6} className='stm-cms-control'>Active</Col>
                                        <Col span={18} className='stm-cms-control'>
                                            <Switch
                                                checked={template.isSelected}
                                                onChange={(value) => this.props.templateStore.setisSelected(value)}
                                                className='' />
                                        </Col>
                                    </>

                                    {/* Theme */}
                                    <>
                                        <Col span={6} className='stm-cms-control'>Home Page Version</Col>
                                        <Col span={18} className='stm-cms-control'>
                                            <Select
                                                value={template.templateSetting.theme}
                                                onChange={(value) => this.props.templateStore.settheme(value)}
                                                className='stm-width-200'>
                                                <Option value={1}>Default</Option>
                                                <Option value={2}>Dark</Option>
                                            </Select>
                                        </Col>
                                    </>

                                    {/* Advanced Settings */}
                                    <Col span={24}>
                                        <Collapse>
                                            <Panel header='Menu'>
                                                {/* Menu Column */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Column</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <InputNumber
                                                            min={1}
                                                            max={4}
                                                            value={template.templateSetting.menu.column}
                                                            onChange={(value) => this.props.templateStore.setmenucolumn(value)}
                                                            className='stm-width-64' />
                                                    </Col>
                                                </>

                                                {/* Margin Top */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Margin Top</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <InputNumber
                                                            min={8}
                                                            value={template.templateSetting.menu.marginTop}
                                                            onChange={(value) => this.props.templateStore.setmenumarginTop(value)}
                                                            className='stm-width-64' />
                                                    </Col>
                                                </>

                                                {/* Margin Bottom */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Margin Bottom</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <InputNumber
                                                            min={8}
                                                            value={template.templateSetting.menu.marginBottom}
                                                            onChange={(value) => this.props.templateStore.setmenumarginBottom(value)}
                                                            className='stm-width-64' />
                                                    </Col>
                                                </>
                                            </Panel>
                                            <Panel header='Background Color'>
                                                {/* Header */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Header</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.header.backgroundColor}
                                                                onChange={color => this.props.templateStore.setheaderBackgroundColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>

                                                {/* Footer */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Footer</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.footer.backgroundColor}
                                                                onChange={color => this.props.templateStore.setfooterBackgroundColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>

                                                {/* Button Item */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Button Item</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.buttonItem.backgroundColor}
                                                                onChange={color => this.props.templateStore.setbuttonItemBackgroundColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>

                                                {/* Button Item Selected*/}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Button Item Selected</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.buttonItemSelected.backgroundColor}
                                                                onChange={color => this.props.templateStore.setbuttonItemSelectedBackgroundColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>

                                                {/* Button Footer */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Button Footer</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.buttonFooter.backgroundColor}
                                                                onChange={color => this.props.templateStore.setbuttonFooterBackgroundColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>
                                            </Panel>
                                            <Panel header='Border Color'>
                                                {/* Button Item */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Button Item</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.buttonItem.borderColor}
                                                                onChange={color => this.props.templateStore.setbuttonItemBorderColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>

                                                {/* Button Item Selected */}
                                                <>
                                                    <Col span={6} className='stm-cms-control'>Button Item Selected</Col>
                                                    <Col span={18} className='stm-cms-control'>
                                                        <div className='stm-cms-box-color-container'>
                                                            <ColorPicker
                                                                className='stm-color-picker'
                                                                hideAlpha={true}
                                                                color={template.templateSetting.buttonItemSelected.borderColor}
                                                                onChange={color => this.props.templateStore.setbuttonItemSelectedBorderColor(color.hex)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </>
                                            </Panel>
                                            <Panel header='Font Settings'>
                                                <>
                                                    {/* Font Settings Header */}
                                                    <>
                                                        <Col span={6} className='stm-margin-bottom-2' />
                                                        <Col span={18} className='stm-margin-bottom-2'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                <Col className='stm-cms-control-font-font-family'>Font Family</Col>
                                                                <Col className='stm-cms-control-font-font-size'>Font Size</Col>
                                                                <Col className='stm-cms-control-font-color'>Color</Col>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Label */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Label</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.label.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setlabelFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.label.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setlabelFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.label.color}
                                                                                onChange={color => this.props.templateStore.setlabelFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Text */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Text</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.text.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.settextFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.text.fontSize}
                                                                                onChange={(value) => this.props.templateStore.settextFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.text.color}
                                                                                onChange={color => this.props.templateStore.settextFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Home Header */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Home Header</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.homeHeader.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.sethomeHeaderFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.homeHeader.fontSize}
                                                                                onChange={(value) => this.props.templateStore.sethomeHeaderFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.homeHeader.color}
                                                                                onChange={color => this.props.templateStore.sethomeHeaderFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Home Info */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Home Info</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.homeInfo.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.sethomeInfoFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.homeInfo.fontSize}
                                                                                onChange={(value) => this.props.templateStore.sethomeInfoFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.homeInfo.color}
                                                                                onChange={color => this.props.templateStore.sethomeInfoFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Menu */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Menu</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.menu.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setmenuFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.menu.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setmenuFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.menu.color}
                                                                                onChange={color => this.props.templateStore.setmenuFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Tab */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Tab</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.tab.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.settabFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.tab.fontSize}
                                                                                onChange={(value) => this.props.templateStore.settabFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.tab.color}
                                                                                onChange={color => this.props.templateStore.settabFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Tab Selected */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Tab Selected</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.tabSelected.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.settabSelectedFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.tabSelected.fontSize}
                                                                                onChange={(value) => this.props.templateStore.settabSelectedFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.tabSelected.color}
                                                                                onChange={color => this.props.templateStore.settabSelectedFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Header */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Header</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.header.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setheaderFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.header.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setheaderFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.header.color}
                                                                                onChange={color => this.props.templateStore.setheaderFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Footer */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Footer</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.footer.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setfooterFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.footer.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setfooterFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                hideAlpha={true}
                                                                                className='stm-color-picker'
                                                                                color={template.templateSetting.footer.color}
                                                                                onChange={color => this.props.templateStore.setfooterFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Button Item */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Button Item</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.buttonItem.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setbuttonItemFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.buttonItem.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setbuttonItemFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                hideAlpha={true}
                                                                                className='stm-color-picker'
                                                                                color={template.templateSetting.buttonItem.color}
                                                                                onChange={color => this.props.templateStore.setbuttonItemFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Button Item Selected */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Button Item Selected</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.buttonItemSelected.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setbuttonItemSelectedFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.buttonItemSelected.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setbuttonItemSelectedFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.buttonItemSelected.color}
                                                                                onChange={color => this.props.templateStore.setbuttonItemSelectedFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                    {/* Button Footer */}
                                                    <>
                                                        <Col span={6} className='stm-cms-control'>Button Footer</Col>
                                                        <Col span={18} className='stm-cms-control'>
                                                            <Row className='stm-cms-control-item-container'>
                                                                {/* Font Family */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <Select
                                                                                value={template.templateSetting.buttonFooter.fontFamily}
                                                                                onChange={(value) => this.props.templateStore.setbuttonFooterFontFamily(value)}
                                                                                className='stm-width-200'>
                                                                                {
                                                                                    fontFamilies.map(fontFamily => {
                                                                                        return (<Option key={fontFamily.value} value={fontFamily.value}>{fontFamily.label}</Option>)
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Font Size */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-control-item-input'>
                                                                            <InputNumber
                                                                                min={10}
                                                                                value={template.templateSetting.buttonFooter.fontSize}
                                                                                onChange={(value) => this.props.templateStore.setbuttonFooterFontSize(value)}
                                                                                className='stm-width-64' />
                                                                        </div>
                                                                    </Col>
                                                                </>

                                                                {/* Color */}
                                                                <>
                                                                    <Col className='stm-cms-control-item'>
                                                                        <div className='stm-cms-box-color-container'>
                                                                            <ColorPicker
                                                                                className='stm-color-picker'
                                                                                hideAlpha={true}
                                                                                color={template.templateSetting.buttonFooter.color}
                                                                                onChange={color => this.props.templateStore.setbuttonFooterFontColor(color.hex)}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            </Row>
                                                        </Col>
                                                    </>

                                                </>
                                            </Panel>
                                        </Collapse>
                                    </Col>

                                    {/* Action */}
                                    <>
                                        <Col span={24} className='stm-margin-top-16'>
                                            <Row>
                                                <Col span={6} />
                                                <Col span={18}>
                                                    <>
                                                        {
                                                            template.id === 0
                                                                ?
                                                                <Button onClick={this.createTemplateOnClick} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Create</Button>
                                                                :
                                                                <Button onClick={this.updateTemplateOnClick} style={{ marginRight: 10 }} type='primary' disabled={hasError}>Update</Button>

                                                        }
                                                    </>
                                                    <Button onClick={this.cancelTemplateOnClick}>Cancel</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>
                                </Row>
                            </Form>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default TemplateUpdate
